module.exports = __webpack_public_path__ + "static/History Newspaper-f51e11a7532bb12d3845e248f72a2de0.jpg";